import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const text: SxStyle = {
  color: (p) => p.palette.common.white,
};
